import type { AllRouteEndpoints } from "../routeTypes";

export const deleteAppGroupIdOperatorMcpConnectionsConnectionIdTokensCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/operator_mcp_connections",
  "/:app_group_id/operator_mcp_connections/:connection_id",
  "/:app_group_id/operator_mcp_connections/tools",
];
